class Account extends HTMLElement {
  constructor() {
      super();
      this.element = this;
      this.delegateElement = new Delegate(this.element);
      this.order = this.element.querySelectorAll(".order-Wrapper");

      this.openOrderBtn = this.element.querySelector('#openOrder');
      this.openHitoryBtn = this.element.querySelector('#historyOrder');

      this.searchBar = this.element.querySelector('#searchBar');

      new Popup(this.element);
      new Dropdown(this.element);
      this.isOpen = false;

      this.bindEvents();


  }
  bindEvents() {
      this.delegateElement.on('click', '[data-action="toggle-active-orders"]', this.showActiveOrders.bind(this));
      this.delegateElement.on('click', '[data-action="toggle-history-orders"]', this.showHistoryOrders.bind(this));
      this.delegateElement.on('keyup', '[data-action="searchItem"]', this.search.bind(this));
      this.delegateElement.on(
          "click",
          '[data-action="delete-address"]',
          this.deleteAddress.bind(this)
      );

  }

  deleteAddress(event) {
      event.preventDefault();
      const id = event.target.getAttribute("data-id");

      Shopify.postLink("/account/addresses/" + id, {
          parameters: { _method: "delete" },
      });
  }

  showActiveOrders() {
      this.order.forEach(function (getOrder) {

          if (getOrder.getAttribute('data-order-status') == 'fulfilled') {
              getOrder.classList.add('hidden');
          }
      })
      this.openOrderBtn.classList.add('active');
      this.openHitoryBtn.classList.remove('active');
  }
  showHistoryOrders() {
      this.order.forEach(function (getOrder) {

          if (getOrder.getAttribute('data-order-status') == 'fulfilled') {
              getOrder.classList.remove('hidden');
          }
      })
      this.openOrderBtn.classList.remove('active');
      this.openHitoryBtn.classList.add('active');
  }
  search() {
      let input = document.getElementById('searchBar').value;
      input = input.toLowerCase();

      var searchableItems = this.element.querySelectorAll('.order-Wrapper');
      var i = 0;

      for (i = 0; i < searchableItems.length; i++) {
          if (!searchableItems[i].innerHTML.toLowerCase().includes(input)) {
              searchableItems[i].style.display = "none";
          } else {
              searchableItems[i].style.display = "block";
          }
      }
  }


}
customElements.define("account-component", Account);

class Login extends HTMLElement {
  constructor() {
      super();
      this.element = this;
      this.delegateElement = new Delegate(this.element);
      this.recoveryForm = this.element.querySelector("#ForgotPass");
      this.loginForm = this.element.querySelector("#logIn");

      if (window.location.href.indexOf("recover") != -1){
          this.openRecover();
      }

      this.bindEvents();
  }

  bindEvents() {
      this.delegateElement.on(
          "click",
          '[data-action="toggle-recovery"]',
          this.openRecover.bind(this)
      );
      this.delegateElement.on(
          "click",
          '[data-action="toggle-login"]',
          this.openLogin.bind(this)
      );
   
  }
  openRecover() {
      event.preventDefault();
      this.recoveryForm.setAttribute('aria-hidden','false');
      this.loginForm.setAttribute('aria-hidden','true');

  }
  openLogin() {
      event.preventDefault();
      this.recoveryForm.setAttribute('aria-hidden','true');
      this.loginForm.setAttribute('aria-hidden','false');

  }

}
customElements.define("customer-login", Login);


class AccountComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    
    new Popup(this.element);

    this.accountHeader = this.element.querySelector('.customerAccount--Header');

  
    this.bindEvents();
    this.handleRefreshState();

  }
  bindEvents(){
    this.delegateElement.on('click', '[data-action="toggle-subtab"]', this.toggleSubTab.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-tab"]', this.toggleTab.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-back"]', this.toggleBack.bind(this));
    this.delegateElement.on(
      "click",
      '[data-action="delete-address"]',
      this.deleteAddress.bind(this)
  );

  this.delegateElement.on("keydown",'[data-action="toggle-tab"]', (event) => {
    if (event.key === 'Enter' ) {
      this.toggleTab(event);
    }
  })
  
  this.delegateElement.on("keydown",'[data-action="toggle-subtab"]', (event) => {
    if (event.key === 'Enter' ) {
      this.toggleSubTab(event);
    }
  })

}



handleRefreshState(){
  if (new Responsive().matchesBreakpoint('lap-and-up')) {
    this.element.querySelector('#contactInfo').setAttribute('aria-visible','true');
  }
      // Get the URL search parameters
      var searchParams = new URLSearchParams(window.location.search);

      // Get the value of param1
      var param1Value = searchParams.get('location');

      // Check if param1 has a value
      if (param1Value) {
        this.toggleTab(false, param1Value);
      }
}

deleteAddress(event) {
  event.preventDefault();
  const id = event.target.getAttribute("data-id");

  Shopify.postLink("/account/addresses/" + id, {
      parameters: { _method: "delete" },
  });
}

toggleBack(){
  const menuTab = this.element.querySelector('.customerAccount--Menu');
  menuTab.style.display = "flex";
  this.accountHeader.style.display = "block";

  const allContent = this.element.querySelectorAll('.customerAccount--Content');
  allContent.forEach((content) => {
    content.setAttribute('aria-visible', 'false');
  });
}

toggleTab(event, paramValue){
    let id = paramValue;
  if (event){
     id = event.target.dataset.id;
  }
 
  const allTabs = this.element.querySelectorAll('.customerAccount--MenuTab[aria-expanded="true"]');
  const allContent = this.element.querySelectorAll('.customerAccount--Content');
  const menuTab = this.element.querySelector('.customerAccount--Menu');


  if (new Responsive().matchesBreakpoint('pocket')) {
    this.accountHeader.style.display = "none";
    menuTab.style.display = "none";
  }


  allTabs.forEach((tab) => {
    tab.setAttribute('aria-expanded', 'false');
  });
  if (event){
    event.target.setAttribute('aria-expanded', 'true');
  } else {
    this.element.querySelector(`[data-id="${id}"]`).setAttribute('aria-expanded', 'true');
  }


  allContent.forEach((content) => {
    if (!content.classList.contains('customerAccount--ContentOrders')){
      content.setAttribute('aria-visible', 'false');
    }

  });

  const content = this.element.querySelector(`#${id}`);
  if (content) {
    content.setAttribute('aria-visible', 'true');
  } 

// Get the current URL
var currentUrl = window.location.href;

// Create a new URL with updated search parameters
var newUrl = currentUrl.split('?')[0] + `?location=${id}`;

// Modify the URL without refreshing the page
window.history.pushState({ path: newUrl }, '', newUrl);

}

  
toggleSubTab(event){

  const id = event.target.dataset.id;
  const allTabs = this.element.querySelectorAll('.customerAccount--toggleTab[aria-expanded="true"]');
  const allContent = this.element.querySelectorAll('.customerAccount--ContentOrders');



  allTabs.forEach((tab) => {
    tab.setAttribute('aria-expanded', 'false');
  });

  event.target.setAttribute('aria-expanded', 'true');

  allContent.forEach((content) => {
    content.setAttribute('aria-visible', 'false');
  });

  const content = this.element.querySelector(`#${id}`);
  if (content) {
    content.setAttribute('aria-visible', 'true');
  } 
}
}


customElements.define("account-component-inner", AccountComponent);



